import React, { Component } from 'react'
import { connect } from 'react-redux'
import { showConfirmationPage, setUserResponse } from '../action/homeAction'

class ConfirmationPopup extends Component {

    onYesClick = () => {
        this.props.showConfirmationPage(false, null, null);
        this.props.setUserResponse("YES");
    }
    onNoClick = () => {
        this.props.showConfirmationPage(false, null, null);
        this.props.setUserResponse("NO");
    }
    render() {
        return (
            <div className="overlay" style={{
                zIndex: 10, position: "absolute", top: "20px", background: "white",
                padding: "20px", margin: "20px"
            }}>
                <div id="svc" className="overlay-body">
                    <div className="primary-response center" style={{ color: "inherit" }}>
                        <div className="wide" style={{ color: "black" }}>
                            {this.props.conformMessage}
                        </div>
                        <button className="btn-yes" onClick={() => { this.onYesClick() }}>
                            {this.props.stringConst.yes}
                        </button>
                        <button className="btn-no" onClick={() => { this.onNoClick() }}>
                            {this.props.stringConst.no}
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        stringConst: state.store.home.stringConst,
        menuColor: state.store.home.MenuColor,
        conformMessage: state.store2.confirmaionPopUp.msgToShow,
        compName: state.store.compName,


    }
}
export default connect(
    mapStateToProps,
    {
        showConfirmationPage,
        setUserResponse
    }
)(ConfirmationPopup);